import { useEffect } from "react";
import { useBlocker } from "react-router-dom";
import { Modal } from "@/components/common/Modal";
import { useCambiosPendientes } from "@/hooks/useCambiosSinGuardar";
import { useClienteActivo } from "@/hooks/useClienteActivo";
import styles from "./UnsavedChangesGuard.module.css";

/**
 * Guardia de formularios a medias (interaction.md §2.4): bloquea el cambio de cliente o de ruta
 * (`useBlocker`, solo si cambia el camino: filtrar con la URL no cuenta) y el cierre de la pestaña
 * (`beforeunload`). «Seguir editando» tiene el foco por defecto y es también lo que hace Esc.
 */
export function UnsavedChangesGuard() {
  const pendientes = useCambiosPendientes();
  const { cliente: activo } = useClienteActivo();
  const sucio = pendientes.length > 0;
  const blocker = useBlocker(({ currentLocation, nextLocation }) => sucio && currentLocation.pathname !== nextLocation.pathname);

  useEffect(() => {
    if (!sucio) return;
    function avisar(event: BeforeUnloadEvent) {
      event.preventDefault();
      event.returnValue = "";
    }
    window.addEventListener("beforeunload", avisar);
    return () => window.removeEventListener("beforeunload", avisar);
  }, [sucio]);

  if (blocker.state !== "blocked") return null;
  const cambio = pendientes[0];
  return (
    <Modal label="Tienes cambios sin guardar" onClose={() => blocker.reset()} width="min(440px, 100%)">
      <h2 className={styles.title}>Tienes cambios sin guardar</h2>
      {cambio ? <p className={styles.body}>En {cambio.seccion} de {cambio.cliente ?? activo?.name ?? "este cliente"}. Si sigues, se perderán.</p> : null}
      <div className={styles.actions}>
        <button type="button" className={styles.secondary} autoFocus onClick={() => blocker.reset()}>Seguir editando</button>
        <button type="button" className={styles.danger} onClick={() => blocker.proceed()}>Descartar y seguir</button>
      </div>
    </Modal>
  );
}
